// Fiyat gönderimi sonucundaki ATLANAN entegrasyonların sebep dökümü (syncProductPrice ve şube
// karşılığı aynı şekli döndürüyor).
//
// Bildirim yalnızca `pushed` yazıyordu: "8 entegrasyona gönderildi". Aktif bağlantı 12 iken
// kalan 4'ün neden atlandığı hiçbir ekranda görünmüyordu — eşleşmemiş bir entegrasyon ile
// fiyatı zaten aynı olan entegrasyon aynı sessizlikte kayboluyordu.
const REASONS = [
  ["unmapped", "entegrasyonda eşleşme yok"],
  ["skipped", "entegrasyonda fiyat zaten aynı"],
  ["noPrice", "entegrasyonda fiyat tanımsız"],
  ["filtered", "entegrasyon grup filtresinde"],
];

export const pushSkipSummary = (result) => {
  const parts = REASONS.filter(([key]) => result?.[key]).map(
    ([key, label]) => `${result[key]} ${label}`,
  );
  const missing = result?.missingRemoteIds?.length ?? 0;

  if (missing) {
    parts.push(`${missing} entegrasyonda ürün bulunamadı`);
  }

  return parts.join(" · ");
};

// "8 entegrasyona fiyat gönderildi · 4 entegrasyonda eşleşme yok"
export const pushSummary = (pushed, result) => {
  const skipped = pushSkipSummary(result);

  return `${pushed} entegrasyona fiyat gönderildi${skipped ? ` · ${skipped}` : ""}`;
};
